var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDaka(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1771550760486,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 75652,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 128,
    height: 128,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M132.096 176.64m120.9856 0l520.96 0q120.9856 0 120.9856 120.9856l0 473.4464q0 120.9856-120.9856 120.9856l-520.96 0q-120.9856 0-120.9856-120.9856l0-473.4464q0-120.9856 120.9856-120.9856Z",
    fill: "#FFE8B2",
    "p-id": 75653
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M249.5488 361.3696v410.0608c0 36.1984 13.568 99.5328 97.9968 116.1216-75.3664 0-211.8144 33.8944-211.8144-140.9536V353.28z",
    fill: "#F7DDA9",
    "p-id": 75654
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M780.9024 361.3696v410.0608c0 36.1984-12.8 99.5328-92.4672 116.1216 71.1168 0 199.68 33.8944 199.68-140.9536V353.28z",
    fill: "#E8BC70",
    "p-id": 75655
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M237.6192 376.5248v398.9504c0 45.7216 22.0672 107.52 104.448 107.52 22.784 0.5632 26.7264-11.8784 26.7264-11.8784s-64.0512 20.9408-64.0512-97.28V372.224z",
    fill: "#FFEECC",
    "p-id": 75656
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M774.0416 174.3872H253.0816A120.9856 120.9856 0 0 0 132.096 295.3728v59.1872h762.88V295.3728a120.9856 120.9856 0 0 0-120.9344-120.9856z",
    fill: "#FF8383",
    "p-id": 75657
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M248.9344 356.096S247.808 302.08 247.808 278.784c0-40.96 32.8192-90.0608 93.1328-96.4608H264.8064c-31.2832 0-129.6896 5.632-129.6896 173.7728z",
    fill: "#FFB8B8",
    "p-id": 75658
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M780.4416 356.096s1.0752-53.9136 1.0752-77.312a98.9184 98.9184 0 0 0-87.808-96.4608h71.68c29.4912 0 122.2656 5.632 122.2656 173.7728z",
    fill: "#FC6565",
    "p-id": 75659
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M292.1472 194.048s-54.4768 8.2944-54.4768 64.256v111.9232h61.0816V258.816c0-23.2448-2.8672-49.8176 51.8144-57.9584a131.1744 131.1744 0 0 0-58.4192-6.8096z",
    fill: "#FFD9D9",
    "p-id": 75660
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M774.0416 148.7872h-61.44v-21.3504a25.6 25.6 0 0 0-51.2 0v21.3504H365.568v-21.3504a25.6 25.6 0 1 0-51.2 0v21.3504H245.4016A146.7392 146.7392 0 0 0 106.496 295.3728V768.768a146.7392 146.7392 0 0 0 146.5856 146.5856h520.96a146.7392 146.7392 0 0 0 146.5856-146.5856V295.3728a146.7904 146.7904 0 0 0-146.5856-146.5856z m-459.6736 51.2v42.24a25.6 25.6 0 1 0 51.2 0v-42.24h295.9872v42.24a25.6 25.6 0 0 0 51.2 0v-42.24h61.44a95.488 95.488 0 0 1 95.3856 95.3856v33.5872H157.696v-33.5872a95.488 95.488 0 0 1 95.3856-95.3856z m459.6736 664.2176H253.0816a95.488 95.488 0 0 1-95.3856-95.3856V380.16h711.68v388.6592a95.488 95.488 0 0 1-95.3344 95.3856z",
    fill: "#434A54",
    "p-id": 75661
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M641.0752 492.5952L486.4 662.272l-83.3536-87.8592a25.6 25.6 0 0 0-37.1712 35.2256l90.3168 95.1296a41.8816 41.8816 0 0 0 30.208 13.056h0.4096a41.8816 41.8816 0 0 0 30.72-13.6704L678.912 527.36a25.6 25.6 0 0 0-37.8368-34.5088z",
    fill: "#434A54",
    "p-id": 75662
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaka);
export default __webpack_public_path__ + "static/media/daka.8b43ac0e.svg";
export { ForwardRef as ReactComponent };